module.exports = __webpack_public_path__ + "img/0.d49b132a.jpg";